<template>
  <div class="apply-agent-page">
    <div class="apply-card">
      <form @submit.prevent="isOk">
        <!-- 姓名 -->
        <div class="form-group-wrap">
          <label>您的姓名</label>
          <input type="text" :value="$store.state.userInfo.realname" disabled placeholder="请输入您的姓名" />
        </div>

        <!-- 联系方式 -->
        <div class="form-group-wrap">
          <label>联系方式</label>
          <input v-model="mobile" type="text" placeholder="请输入您的联系方式" />
        </div>

        <!-- 申请理由 -->
        <div class="form-group-wrap">
          <label>申请理由</label>
          <textarea v-model="apply_info" placeholder="请输入申请理由"></textarea>
        </div>

        <!-- 提交按钮 -->
        <button type="submit" class="submit-button">确认申请</button>
      </form>

      <!-- 提示弹窗 -->
      <div class="pay-dialog" v-if="showDialog">
        <div class="pay-password">
          <div class="pay-password__header">提示</div>
          <p class="pay-password__title">请您先绑定手机号后，再设置资金密码</p>
          <a href="javascript:void(0);" class="pay-password__button" @click="goBindMobile">前往设置</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'applyagent',
  data() {
    return {
      mobile: '',
      apply_info: '',
      showDialog: false
    };
  },
  methods: {
    isOk() {
      const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(this.mobile)) {
        this.$parent.showTost(0, '请输入正确手机号');
        return;
      }
      if (!this.apply_info) {
        this.$parent.showTost(0, '请输入申请理由');
        return;
      }

      this.$parent.showLoading();
      this.$apiFun
        .post('/api/applyagentdo', { mobile: this.mobile, apply_info: this.apply_info })
        .then(res => {
          this.$parent.showTost(1, res.message);
        })
        .catch(() => {
          this.$parent.showTost(0, '申请失败，请稍后重试');
        })
        .finally(() => {
          this.$parent.hideLoading();
        });
    },
    goBindMobile() {
      // 跳转到绑定手机号页面
      this.$parent.goNav('/bindMobile');
      this.showDialog = false;
    }
  }
};
</script>

<style scoped>
.apply-agent-page {
  background-color: #f5f7fa;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 30px 15px;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.apply-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  width: 100%;
  max-width: 480px;
  padding: 30px;
}

.form-group-wrap {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

label {
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
  font-size: 14px;
}

input, textarea {
  background: #f9fafb;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  color: #334155;
  outline: none;
  transition: border 0.2s;
}

input:focus, textarea:focus {
  border-color: #3b82f6;
}

textarea {
  resize: vertical;
  min-height: 80px;
}

.submit-button {
  width: 100%;
  background: linear-gradient(224deg, #ffdf91, #ffcb4c);
  color: #482000;
  font-weight: 600;
  font-size: 16px;
  height: 46px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-button:hover {
  transform: translateY(-2px);
  background: linear-gradient(224deg, #ffe7a8, #ffc436);
}

/* 提示弹窗 */
.pay-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.pay-password {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px 25px;
  text-align: center;
  max-width: 320px;
}

.pay-password__header {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 15px;
}

.pay-password__title {
  font-size: 14px;
  color: #334155;
  margin-bottom: 20px;
}

.pay-password__button {
  display: inline-block;
  padding: 8px 20px;
  background: #3b82f6;
  color: #fff;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
}

.pay-password__button:hover {
  background: #2563eb;
}

/* 响应式 */
@media (max-width: 480px) {
  .apply-card {
    padding: 20px;
  }
  input, textarea {
    font-size: 13px;
  }
  .submit-button {
    font-size: 15px;
    height: 44px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/applyagent.vue